import mapKeys from 'lodash/mapKeys'

import { isEmpty } from 'lodash'

import {
  USERS_GET_FULFILLED,
  USERS_GET_PENDING,
  USERS_GET_REJECTED,
  USERS_SORT_BY_SET,
  USERS_SORT_ORDER_SET,
  USER_CREATE_FULFILLED,
  USER_CREATE_PENDING,
  USER_CREATE_REJECTED,
} from './actionTypes'

import {
  DETAIL_USER_EMAIL_CHANGE_FULFILLED,
  DETAIL_USER_FIRST_NAME_CHANGE_FULFILLED,
  DETAIL_USER_LAST_NAME_CHANGE_FULFILLED,
} from 'Modules/UserDetailModule/actionTypes'

const initialState = {
  create: {
    createdUser: null,
    hasError: false,
    isPending: false,
  },
  errors: {
    getUsers: false,
  },
  sortBy: 'email',
  sortOrder: 'ascending',
  pendings: {
    getUsers: false,
  },
  users: {},
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case USER_CREATE_FULFILLED:
      return {
        ...state,
        users: {
          ...state.users,
          [payload.data.id]: {
            ...payload.data,
          },
        },
        create: {
          ...state.create,
          createdUser: payload.data.id,
          hasError: false,
          isPending: false,
        },
      }

    case USER_CREATE_PENDING:
      return {
        ...state,
        create: {
          ...state.create,
          hasError: false,
          isPending: true,
        },
      }

    case USER_CREATE_REJECTED:
      return {
        ...state,
        create: {
          ...state.create,
          hasError: true,
          isPending: false,
        },
      }

    case USERS_GET_FULFILLED:
      return {
        ...state,
        errors: {
          ...state.errors,
          getUsers: false,
        },
        pendings: {
          ...state.pendings,
          getUsers: false,
        },
        users: mapKeys(payload.data, 'id'),
      }

    case USERS_GET_PENDING:
      return {
        ...state,
        errors: {
          ...state.errors,
          getUsers: false,
        },
        pendings: {
          ...state.pendings,
          getUsers: true,
        },
      }

    case USERS_GET_REJECTED:
      return {
        ...state,
        errors: {
          ...state.errors,
          getUsers: true,
        },
        pendings: {
          ...state.pendings,
          getUsers: false,
        },
      }

    case USERS_SORT_BY_SET:
      return {
        ...state,
        sortBy: payload,
      }

    case USERS_SORT_ORDER_SET:
      return {
        ...state,
        sortOrder: payload,
      }
    case DETAIL_USER_EMAIL_CHANGE_FULFILLED:
      if (!isEmpty(state.users)) {
        return {
          ...state,
          users: {
            ...state.users,
            [payload.data.id]: payload.data,
          },
        }
      } else {
        return state
      }

    case DETAIL_USER_FIRST_NAME_CHANGE_FULFILLED:
      if (!isEmpty(state.users)) {
        return {
          ...state,
          users: {
            ...state.users,
            [payload.data.id]: payload.data,
          },
        }
      } else {
        return state
      }

    case DETAIL_USER_LAST_NAME_CHANGE_FULFILLED:
      if (!isEmpty(state.users)) {
        return {
          ...state,
          users: {
            ...state.users,
            [payload.data.id]: payload.data,
          },
        }
      } else {
        return state
      }

    default:
      return state
  }
}

export default reducer
